export class StatusConst{

  public static DRAFT:string = "DRAFT";
  public static SUBMITED: string = "SUBMITED";
  public static ACCEPTED: string = "ACCEPTED";

}
